// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__szz3X","title":"styles_title__gNcRE"};